interface ProgressDotsProps {
  total: number;
  current: number;
}

export function ProgressDots({ total, current }: ProgressDotsProps) {
  const dots = Array.from({ length: total }, (_, i) => i + 1);
  return (
    <div
      className="progress-dots"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
    >
      {dots.map((step) => {
        const state =
          step < current
            ? 'progress-dot--complete'
            : step === current
              ? 'progress-dot--active'
              : '';
        return <span key={step} className={`progress-dot ${state}`.trim()} />;
      })}
    </div>
  );
}
